
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Server.WebAccess.Build.Plugins
//----------------------------------------------------------


export module CIDataProviderKeys {
    export var Builds = "TFS.CI.Builds";
    export var Definitions = "TFS.CI.Definitions";
}

export module DataProviderKeys {
    export var MyDefinitions = "TFS.Build.MyDefinitions";
    export var AllDefinitions = "TFS.Build.AllDefinitions";
    export var AllDefinitions2 = "TFS.Build.AllDefinitions2";
    export var QueuedDefinitions = "TFS.Build.QueuedDefinitions";
    export var AllBuilds = "TFS.Build.AllBuilds";
    export var DefinitionSummary = "TFS.Build.DefinitionSummary";
    export var DefinitionHistory = "TFS.Build.DefinitionHistory";
    export var DefinitionDeletedHistory = "TFS.Build.DefinitionDeletedHistory";
    export var Builds = "TFS.Build.Builds";
    export var Changes = "TFS.Build.Changes";
    export var Definitions = "TFS.Build.Definitions";
    export var Folders = "TFS.Build.Folders";
    export var Queues = "TFS.Build.Queues";
    export var BuildHistory = "TFS.Build.BuildHistory";
    export var NewCIWorkflowOptInState = "TFS.Build.NewCIWorkflowOptInState";
    export var NewCIWorkflowPreviewFeatureState = "TFS.Build.NewCIWorkflowPreviewFeatureState";
    export var AllDefinitionIds = "TFS.Build.AllDefinitions.DefinitionIds";
    export var BuildIds = "TFS.Build.Mine.BuildIds";
    export var HasMyBuilds = "TFS.Build.Mine.HasMyBuilds";
    export var MyFavoriteDefinitionIds = "TFS.Build.MyFavoriteDefinitionIds";
    export var TeamFavoriteDefinitionIds = "TFS.Build.TeamFavoriteDefinitionIds";
    export var BuildsContinuationToken = "TFS.Build.Builds.ContinuationToken";
    export var DefinitionsContinuationToken = "TFS.Build.Definitions.ContinuationToken";
    export var SignalRActionUrl = "TFS.Build.SignalR.ActionUrl";
    export var SignalRHubsUrl = "TFS.Build.SignalR.HubsUrl";
}

